export enum DashboardStyle {
    smallCharts,
    dualCharts,
    sections
}